<template src="../../templates/form/farm-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'FarmForm',
    props: ['farmToUpdate'],
    components: {
        Modal
    },
    data() {
        return {
            farm: {
                id: this.farmToUpdate.id,
                name: this.farmToUpdate.name,
                manager: this.farmToUpdate.manager,
                address: this.farmToUpdate.address
            }
        }
    },
    computed: {
        ...mapGetters(['isMobile']),
        isFormValid() {
            return this.farm.id != null
                ? !this.$v.farm.name.$invalid &&
                      !this.$v.farm.manager.$invalid &&
                      (this.farm.name !== this.farmToUpdate.name ||
                          this.farm.manager !== this.farmToUpdate.manager)
                : !this.$v.farm.name.$invalid && !this.$v.farm.manager.$invalid
        }
    },
    validations: {
        farm: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(15)
            },
            manager: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(15)
            },
            address: {
                maxLength: maxLength(15)
            }
        }
    },
    methods: {
        ...mapActions(['createFarm', 'updateFarm']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                if (this.farm.id !== null) {
                    this.updateFarm(this.farm)
                } else {
                    this.createFarm(this.farm)
                }
                this.close()
            }
        }
    }
}
</script>

<style lang="sass">
    @import '../../sass/mixin/color'

    #farm-modal
        .modal-header
            background-color: $pc_niceyellow
            color: white
        .modal-body
            .farm-form
                input
                    border-left-color: 8px solid lighten($pc_niceyellow, 7%)
                input:focus
                    border-left: 8px solid lighten($pc_niceyellow, 21%)
                input:valid
                    border-left: 8px solid lighten($pc_niceyellow, 21%)
</style>
